import { useState } from "react";

export const CourseModal = () => {
  const [selected, setSelected] = useState("");
  const [modalView, setModalVeiw] = useState(true);
  const handleSelect = (e) => {
    setSelected(e.target.value);
  };
  const handleSubmit = () => {
    if (!selected) return;
    if (selected === "Self-pace") {
      window.location.href = "https://online.reworkacademy.co/";
    } else {
      setModalVeiw(false);
    }
  };
  return (
    <div className={`course-modal ${!modalView ? "course-modal__view" : ""}`}>
      <div className="course-modal__content">
        <h2>Choose Class Option</h2>
        <p>You can choose to learn online(self-pace), anywhere, anytime, or a physical classroom(Abuja).</p>
        <div className="course-modal__inputs">
          <div>
            <input type="radio" name="class_option" value="Self-pace" onChange={handleSelect} /> Online(Self-pace)
          </div>
          <div>
            <input type="radio" name="class_option" value="Physical" onChange={handleSelect} /> Physical Classroom
          </div>
        </div>
        <div className="course-modal__btns">
          <button className="link__btn link__btn-bg-grey" onClick={() => setModalVeiw(false)}>
            Cancel
          </button>
          <button className="link__btn link__btn-bg-blue" onClick={handleSubmit}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};
